module.exports = __webpack_public_path__ + "media/src/images/partners/mhmk-c7e07a6ea95addba99d641f2e47ced01.jpg";